import React from 'react'
import { Button, Grid, CircularProgress } from '@mui/material'
import RefreshIcon from '@mui/icons-material/Refresh'
import '../live-data-view-style.scss'

const DataRow = ({ label, value, unit }) => (
    <div className="data-row">
        <span className="data-label">{label}</span>
        <span className="data-value">{value}{unit && <span className="unit">{unit}</span>}</span>
    </div>
)

const DataCard = ({ title, subtitle, statusIcon, statusText, children }) => (
    <div className="data-card">
        <div className="card-header">
            <div>
                <h3 className="card-title">{title}</h3>
                {subtitle && <p className="card-subtitle">{subtitle}</p>}
            </div>
            {statusIcon && (
                <div className="card-status">
                    <img src={statusIcon} alt="status" className="status-icon" />
                    {statusText && <span className="status-text">{statusText}</span>}
                </div>
            )}
        </div>
        <div className="card-body">{children}</div>
    </div>
)

const LiveDataViewDesktop = ({ logic }) => {
    const { fetchedData, calculatedData, calculatedInverters, loading, handleRefresh } = logic

    return (
        <div className="live-data-view-container">
            <div className="live-data-content">
                {loading && <div className="loading-overlay"><CircularProgress size={40} /><span>Updating live data...</span></div>}
                <section className="data-section fetched-section">
                    <div className="section-header space-between space-after-section">
                        <div><h2 className="section-title">Fetched (Real-Time Data)</h2><p className="section-description">Latest device readings from IoT sensors</p></div>
                        <div className="section-actions"><Button variant="contained" startIcon={<RefreshIcon />} onClick={handleRefresh} disabled={loading} className="refresh-button">{loading ? 'Refreshing...' : 'Refresh'}</Button></div>
                    </div>
                    <div className="section-grid">
                        <Grid container spacing={2}>
                            {fetchedData.inverters.length > 0 ? fetchedData.inverters.map(inv => (
                                <Grid item xs={12} sm={6} key={inv.inverterID}>
                                    <DataCard title={inv.inverterID} subtitle={inv.name} statusIcon={inv.statusIcon} statusText={inv.status}>
                                        {inv.model && <DataRow label="Model" value={inv.model} />}
                                        <DataRow label="Power" value={inv.power.value} unit={` ${inv.power.unit}`} />
                                        <DataRow label="Status" value={inv.status} />
                                        <DataRow label="Today Generation" value={inv.todayGeneration.value} unit={` ${inv.todayGeneration.unit}`} />
                                    </DataCard>
                                </Grid>
                            )) : <Grid item xs={12}><div className="data-card no-data"><p>No inverter data available</p></div></Grid>}
                            <Grid item xs={12} sm={6}>
                                <DataCard title={fetchedData.sensor.sensorID} subtitle={fetchedData.sensor.name} statusIcon={fetchedData.sensor.statusIcon} statusText={fetchedData.sensor.status}>
                                    <DataRow label="Model Name" value={fetchedData.sensor.modelName} />
                                    <DataRow label="Temperature" value={fetchedData.sensor.temperature.value} unit={` ${fetchedData.sensor.temperature.unit}`} />
                                    <DataRow label="Irradiance" value={fetchedData.sensor.irradiance.value} unit={` ${fetchedData.sensor.irradiance.unit}`} />
                                    <DataRow label="Irradiation" value={fetchedData.sensor.irradiation.value} unit={` ${fetchedData.sensor.irradiation.unit}`} />
                                </DataCard>
                            </Grid>
                        </Grid>
                    </div>
                </section>
                <section className="data-section calculated-section">
                    <div className="section-header"><h2 className="section-title">Calculated (Daily Comparison)</h2><p className="section-description">Previous day vs current day energy values</p></div>
                    <div className="section-grid">
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={6}>
                                <DataCard title={calculatedData.meter.meterID} subtitle={calculatedData.meter.name} statusIcon={calculatedData.meter.statusIcon} statusText={calculatedData.meter.status}>
                                    <DataRow label="Status" value={calculatedData.meter.status} />
                                    <DataRow label="Last Energy Export Till" value={calculatedData.meter.lastEnergyExport.value} unit={` ${calculatedData.meter.lastEnergyExport.unit}`} />
                                    <DataRow label="Current Energy Export Till" value={calculatedData.meter.current.value} unit={` ${calculatedData.meter.current.unit}`} />
                                    <DataRow label="Multiplying Factor" value={calculatedData.meter.multiplyingFactor.value} unit={` ${calculatedData.meter.multiplyingFactor.unit}`} />
                                    <DataRow label="Today Generation" value={calculatedData.meter.todayGeneration.value} unit={` ${calculatedData.meter.todayGeneration.unit}`} />
                                </DataCard>
                            </Grid>
                            {calculatedInverters.map(inv => (
                                <Grid item xs={12} sm={6} key={inv.inverterID}>
                                    <DataCard title={inv.inverterID} subtitle={inv.name} statusIcon={inv.statusIcon} statusText={inv.status}>
                                        {inv.model && <DataRow label="Model" value={inv.model} />}
                                        <DataRow label="Status" value={inv.status} />
                                        <DataRow label="Last Inverter Till Generation" value={inv.last.value} unit={` ${inv.last.unit}`} />
                                        <DataRow label="Current Inverter Till Generation" value={inv.current.value} unit={` ${inv.current.unit}`} />
                                        <DataRow label="Today Generation" value={inv.todayGeneration.value} unit={` ${inv.todayGeneration.unit}`} />
                                    </DataCard>
                                </Grid>
                            ))}
                        </Grid>
                    </div>
                </section>
            </div>
        </div>
    )
}

export default LiveDataViewDesktop
